<freud-dialog
	[closable]="false"
	[modal]="true"
	[header]="'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.TITLE' | translate"
	[(visible)]="isVisible"
>
	<div class="zk-flex zk-flex-col">
		<p freud-typography fontType="bodyRegular1">
			{{ title() }}
		</p>
	</div>

	<div class="zk-flex zk-flex-row zk-mt-4 zk-mb-4 busy-slot" *ngFor="let busySlot of busySlots">
		<div class="icon">	
			<span class="freud-icon freud-icon-calendar-event freud-icon-small"></span>
		</div>
		<div class="zk-flex zk-flex-col">
			<div class="title">
				<span>{{ busySlotTitle(busySlot) }}</span>
			</div>
			<div class="date">
				<span>{{ busySlotDate(busySlot) }}</span>
			</div>
		</div>
	</div>

	<div class="zk-flex zk-flex-col">
		<p freud-typography fontType="bodyRegular1">
			{{ footer() }}
		</p>
	</div>
	
	<ng-container freudTemplatefooter>
		<div class="zk-flex" *ngIf="!isLoading">
			<freud-button color="ghost" (click)="closeModal(true)">{{ 'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.ACTIONS.CANCEL' | translate }}</freud-button>
			<freud-button (click)="confirm()"> {{ 'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.ACTIONS.CONFIRM' | translate }} </freud-button>
		</div>		
		<div class="loader__wrapper" *ngIf="isLoading">
			<freud-loader></freud-loader>
		</div>
	</ng-container>
</freud-dialog>
